import { useAuth0 } from "src/contexts/auth0Provider";
import {
  TENANT_ROLE_RESOURCES,
  hasAdminRole,
  isInternalSupportUser,
  userHasGroupRole,
} from "src/services/auth";
import { isEnvTrue } from "src/services/env";

import useTenantRoleNames from "./useTenantRoleNames";

/**
 * Whether the current user can manage tenant-level design access (e.g.
 * grant/revoke design admin). Mirrors the backend authorisation: a user is
 * allowed when they have the DTA-{tenantId} role on the current tenant.
 * Internal-support users always pass for parity with canPerform().
 *
 * @returns {boolean}
 */
const useCanManageDesignAccess = () => {
  const { user } = useAuth0() || {};
  const designRoles = useTenantRoleNames(TENANT_ROLE_RESOURCES.DESIGN);

  if (!user) {
    return false;
  }

  if (isInternalSupportUser(user)) {
    return true;
  }

  // ponytail: mirror designFeatureGuard offline ADMIN bypass — local stacks
  // cannot assign DTA-* via Auth0 without M2M secrets.
  if (isEnvTrue(process.env.REACT_APP_IS_OFFLINE) && hasAdminRole(user)) {
    return true;
  }

  return userHasGroupRole(user, designRoles.ADMIN);
};

export default useCanManageDesignAccess;
